import Color from '@/Enums/Color.enum';
import NumberInput from '@/components/NumberInput';
import { FormLabel, InputAdornment, TextField } from '@mui/material';
import ClearButton from './styled/ClearButton';

type CalculatorField = 'impressions' | 'cpm' | 'budget';

interface MetricInputProps {
  field: CalculatorField;
  label: string;
  hasValue: boolean;
  value: string;
  isCalculated: boolean;
  showClearButton: boolean;
  error?: string;
  showDollarSign?: boolean;
  fractionDigits?: number;
  placeholder?: string;
  onClear: () => void;
  onChange: (eventOrValue: string | { target: { value: string } }) => void;
  onBlur?: () => void;
}

const inputStyles = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'white',
  },
  '& .MuiOutlinedInput-root.Mui-disabled': {
    backgroundColor: Color.DisabledBackground,
  },
  '& .MuiOutlinedInput-input.Mui-disabled': {
    WebkitTextFillColor: Color.TextDark,
  },
  '& .MuiInputAdornment-root': {
    marginRight: '0',
  },
};

const MetricInput = ({
  field,
  label,
  hasValue,
  value,
  isCalculated,
  showClearButton,
  error,
  showDollarSign = false,
  fractionDigits = 0,
  placeholder,
  onClear,
  onChange,
  onBlur,
}: MetricInputProps) => {
  const inputId = `calculator-${field}`;

  return (
    <div className='flex flex-col gap-1'>
      <div className='flex justify-between items-center'>
        <FormLabel htmlFor={inputId} sx={{ fontSize: '0.75rem', fontWeight: 500, color: Color.Grey }}>
          {label}
        </FormLabel>
        {hasValue && showClearButton && (
          <ClearButton variant='text' size='small' onClick={onClear}>
            Clear
          </ClearButton>
        )}
      </div>
      {isCalculated ? (
        <TextField
          id={inputId}
          type='text'
          size='small'
          value={value}
          disabled
          sx={inputStyles}
          slotProps={{
            input: showDollarSign ? { startAdornment: <InputAdornment position='start'>$</InputAdornment> } : undefined,
          }}
        />
      ) : (
        <NumberInput
          // @ts-expect-error jsx component prop
          id={inputId}
          fullWidth
          size='small'
          value={value}
          onChange={onChange}
          error={!!error}
          helperText={error}
          placeholder={placeholder}
          disableInputArrows
          NumberInputProps={{
            thousandsSeparator: ',',
            unmask: true,
            min: 0,
            maximumFractionDigits: fractionDigits,
          }}
          InputProps={
            showDollarSign ? { startAdornment: <InputAdornment position='start'>$</InputAdornment> } : undefined
          }
          sx={inputStyles}
          onBlur={onBlur}
        />
      )}
    </div>
  );
};

export default MetricInput;
